/* eslint-disable */
import api from '@/utils/backend-api'
export default {
  namespaced: true,
  state: {
    Students: '',
    teacherTime: '',
    studentdetails: '',
    studentTeacherdetails: '',
    subscription: ''
  },
  mutations: {
    setModulesData(state, {
      Students
    }) {
      state.Students = Students
    },
    setTeacherTime(state, {
      teacherTime
    }) {
      state.teacherTime = teacherTime
    },
    setStudentsData(state, {
      Students
    }) {
      state.Students = Students
    },
    setStudentData(state, studentdetails) {
      state.studentdetails = studentdetails
    },
    setStudentTeacherData(state, studentTeacherdetails) {
      state.studentTeacherdetails = studentTeacherdetails
    },
    setStudentSubscriptionuData(state, Subscription) {
      state.subscription = Subscription
    },
    reset(state) {
      state.Students = ''
      state.teacherTime = ''
      state.studentdetails = ''
      state.studentTeacherdetails = ''
      state.subscription = ''
    }
  },
  actions: {
    getAllStudents({
      commit
    }) {
      return new Promise(function (resolve, reject) {
        api.getData('admin/student')
          .then((response) => {
            var Students = response.data
            commit('setModulesData', {
              Students
            })
            resolve(Students)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    AddStudent({
      commit
    }, Data) {
      return new Promise(function (resolve, reject) {
        api.postData('admin/student/signup', Data)
          .then((response) => {
            var Students = response.data
            resolve(Students)
          }).catch((error) => {
            reject(error)
          })

      })
    },
    getTeacherTime({
      commit
    }, Data) {
      return new Promise(function (resolve, reject) {
        api.postData('admin/student_class/get_time', Data)
          .then((response) => {
            if (response.status == 200) {
              var teacherTime = response.data
              commit('setTeacherTime', {
                teacherTime
              })
              resolve(response)
            } else if (response.status == 204) {
              resolve(response)
            } else if (response.status == 203) {
              resolve(response)
            }
          }).catch((error) => {
            resolve(error)
          })
      })

    },
    adminBookStudentClass({
      commit
    }, {
      data
    }) {
      return new Promise(function (resolve, reject) {
        api.postData("admin/student_class/book", data)
          .then(res => {
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    adminUpdateStudentBookedClass({
      commit
    }, {
      data
    }) {
      return new Promise(function (resolve, reject) {
        api.postData("admin/student_class/update", data)
          .then(res => {
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    cancelBookedClass({
      commit
    }, data) {
      return new Promise(function (resolve, reject) {
        debugger
        api.postData("admin/student_class/student_cancel", data)
          .then(res => {
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    getSubscriptionInformation({
      commit
    }, studentId) {
      return new Promise(function (resolve, reject) {
        api.postData('admin/student_invoice', studentId)
          .then((response) => {
            var Subscription = response.data
            commit('setStudentSubscriptionuData', {
              Subscription
            })
            resolve(Subscription)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    changeStudentStatus({
      commit
    }, Data) {
      api.postData("admin/student/status/" + Data.studentid, {
          "status": Data.status
        })
        .then(res => {})
        .catch(function (error) {

        })
    },
    getStudentById({
      commit
    }, id) {
      if (id) {
        api.getData('admin/student/' + id).then(
          res => {
            var students = res.data
            commit('setStudentData', students)
          })
      }
    },
    getClassDetails(id) {

    },
    studentEdit({
      commit
    }, Data) {
      return new Promise(function (resolve, reject) {
        api.postData('admin/student/' + Data.StudentId, Data.StudentDetails)
          .then(res => {
            commit('setStudentsData', res.Data)
            resolve(res.Data)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    getStudentById({
      commit
    }, id) {
      if (id) {
        api.getData('admin/student/' + id).then(
          res => {
            var students = res.data
            commit('setStudentData', students)
          })
      }
    },
    setStudentsData({
      commit
    }, Data) {
      commit('setStudentsData', Data)
    },
    getStudentTeacherById({
      commit
    }, student_id) {
      console.log("getStudentTeacherById")
      console.log(student_id)
      if (student_id) {
        api.postData('admin/view_teacher_for_student', {
          "student_id": student_id
        }).then(
          res => {
            var students = res.data
            commit('setStudentTeacherData', students)
          }).catch(err => {
          console.log("Error")
          commit('setStudentTeacherData', [])

        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Student.js